module.exports = __webpack_public_path__ + "static/media/kris.e2ffa5eb.jpg";